/**
 * D6DamageExtraFieldType - Type d'extraField pour les Dégâts D6
 * Identique à PlayerDamageExtraField.java
 */

import {ExtraFieldType} from '../../types/ExtraFieldType';
import {GameDataExtraField} from '../../../models/GameDataExtraField';
import {GameState} from '../../../models/GameState';
import {getValueDice} from '../util/DiceUtil';

export class D6DamageExtraFieldType implements ExtraFieldType {
  typeName = 'D6_DAMAGE';
  defaultValue = '1';

  process(field: GameDataExtraField, gameState: GameState): void {
    // Pas de traitement spécial nécessaire
  }

  /**
   * Génère une valeur à partir d'une expression D6
   * Utilise DiceUtil.getValueDice() comme en Java
   * 
   * @param fieldValue Expression D6 (ex: "1", "1D+2", "2D")
   * @returns Valeur générée (ex: "1", "3", "12")
   */
  generateValue(fieldValue: string): string {
    return getValueDice(fieldValue).toString();
  }
}
